skrilla.controller('createUserPromotionDepositModalCtrl', function ($scope, searchService, cacheService, modalService, currencyService, validationService) {
    $scope.validate = {}
    $scope.newTransaction = cacheService.getObjectOrElse("newPromotionTransaction", function(){
        modalService.dismissAll();
    });

    $scope.create = function () {
        if(validate()){
            modalService.confirm("Are you sure you'd like to create this transaction?", function () {
                const request = {...$scope.newTransaction, amount: currencyService.multiply($scope.newTransaction.amount, $scope.newTransaction.currency)}
                searchService.post("users/" + $scope.newTransaction.userId + "/manualBonusTransaction", request, "Manual Deposit Successfully Created!").then(function (response) {
                    modalService.dismissAll();
                });
            });
        }
    }

    function validate() {
        let inputs = [
            validationService.buildFieldValidationObj("reason", validationService.isNotEmpty($scope.newTransaction.reason), "Please provide a reason"),
            validationService.buildFieldValidationObj("description", validationService.isNotEmpty($scope.newTransaction.description), "Please provide a description"),
            validationService.buildFieldValidationObj("amount", validationService.isNumberGreaterThanZero($scope.newTransaction.amount), "Please provide a valid deposit amount"),
        ]

        return validationService.validateForm(inputs, $scope.validate)
    }

});